import type { MouseEvent } from 'react'
import { appConfig } from './query'

/** In-app deep link to an issue's full-page view — also the sharable URL. */
export function issueHref(number: number): string {
  return `/issues/${number}`
}

/** Absolute github.com URL for an issue in the work repo. */
export function githubIssueUrl(number: number): string {
  return `https://github.com/${appConfig.owner}/${appConfig.repo}/issues/${number}`
}

/** Absolute github.com URL for an issue in any repo (cross-repo references). */
export function githubIssueUrlIn(repoFullName: string, number: number): string {
  return `https://github.com/${repoFullName}/issues/${number}`
}

/** A click the browser should service itself rather than us hijacking it: any
 *  modifier key or a non-primary (e.g. middle) button. On a real <a> we leave
 *  these alone, so Cmd/Ctrl/Shift-click and middle-click open a new tab/window
 *  exactly as they would for any other link. */
export function isModifiedClick(e: MouseEvent): boolean {
  return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0
}
